import { HttpRequest } from '../../components/HttpRequest';
import secureLocalStorage from 'react-secure-storage';

class BusinessService {
  /**
   * Get business ID from storage or fetch from API
   * This ensures businessId is always available across the app
   */
  async getBusinessId() {
    try {
      // Check if businessId already exists in secure storage
      let businessId = secureLocalStorage.getItem('businessId');

      if (businessId) {
        return businessId;
      }

      // If not, fetch from API using current domain
      businessId = await this.fetchBusinessIdFromDomain();

      if (businessId) {
        secureLocalStorage.setItem('businessId', businessId);
        return businessId;
      }

      console.warn('Unable to retrieve businessId');
      return null;
    } catch (error) {
      console.error('Error getting business ID:', error);
      return null;
    }
  }

  /**
   * Fetch business ID from API using current domain
   */
  async fetchBusinessIdFromDomain() {
    try {
      const currentDomain = window.location.origin;
      const response = await HttpRequest({
        method: 'GET',
        url: `/api/v1/ecommerce/getzedecommerce-domain-details?subdomain=${currentDomain}`,
      });

      if (response?.status === 200 && response?.response?.businessNumber) {
        return response.response.businessNumber;
      }

      return null;
    } catch (error) {
      console.error('Error fetching business ID from domain:', error);
      return null;
    }
  }

  /**
   * Set business ID in storage
   */
  setBusinessId(businessId) {
    if (businessId) {
      secureLocalStorage.setItem('businessId', businessId);
    }
  }

  /**
   * Clear business ID from storage
   */
  clearBusinessId() {
    secureLocalStorage.removeItem('businessId');
  }

  /**
   * Initialize business context on app load
   * This should be called in the main layout/route component
   */
  async initializeBusinessContext() {
    try {
      const businessId = await this.getBusinessId();
      return businessId;
    } catch (error) {
      console.error('Error initializing business context:', error);
      return null;
    }
  }

  /**
   * Get business ID synchronously (returns from storage only)
   * Use this when you need immediate access without async operations
   */
  getBusinessIdSync() {
    return secureLocalStorage.getItem('businessId');
  }
}

const businessService = new BusinessService();
export default businessService;
